import { createAsyncThunk, AsyncThunkPayloadCreator } from '@reduxjs/toolkit';
import { TRootState } from '../../..';

export function makeListThunk<
  Returned,
  ThunkArg extends Record<string, unknown> = Record<string, unknown>,
>(
  name: string,
  payloadCreator: AsyncThunkPayloadCreator<
    Returned,
    { listId: string; avoidSynchronize?: boolean } & ThunkArg,
    { state: TRootState }
  >,
) {
  const thunk = createAsyncThunk<Returned, { listId: string } & ThunkArg>(
    name,
    (...args) => {
      return payloadCreator(...args);
    },
  );
  return thunk;
}
